<div class="active-issues-page">
  <header class="active-issues-header">
    <div class="active-issues-header__identity">
      <div class="active-issues-header__icon" aria-hidden="true">
        <i class="pi pi-list"></i>
      </div>

      <div class="active-issues-header__copy">
        <h1>Active Issues</h1>
        <p>Issue queue <span>&middot;</span> Updated just now</p>
      </div>
    </div>

    <div class="active-issues-header__status" aria-label="Open issues">
      <span class="active-issues-header__status-dot"></span>
      <span>Open issues</span>
    </div>
  </header>

  <div class="active-issues-content">
    <div class="grid">
      <!-- active issues stats -->
      <div class="col-12" *ngIf="false">
        <div class="surface-card shadow-2 flex p-3 flex-column md:flex-row">
          <div
            class="border-bottom-1 md:border-right-1 md:border-bottom-none surface-border flex-auto p-3"
          >
            <div class="flex align-items-center mb-3">
              <i class="pi pi-exclamation-circle text-red-500 text-xl mr-2"></i>
              <span class="text-500 font-medium">Active Issues</span>
            </div>
            <span class="block text-900 font-medium mb-4 text-xl"
              >152 New (since yesterday)</span
            >
            <div class="flex align-items-center">
              <i class="pi pi-arrow-down text-green-500 text-xl mr-2"></i>
              <span class="text-green-500 font-medium">-25</span>
            </div>
          </div>

          <!-- 2nd header box -->
          <div
            class="border-bottom-1 md:border-bottom-none surface-border flex-1 p-3"
          >
            <div class="flex align-items-center mb-3">
              <i class="pi pi-shopping-cart text-orange-500 text-xl mr-2"></i>
              <span class="text-500 font-medium">Resolved Issues</span>
            </div>
            <span class="block text-900 font-medium mb-4 text-xl">$1500</span>
            <div class="flex align-items-center">
              <i class="pi pi-arrow-up text-green-500 text-xl mr-2"></i>
              <span class="text-green-500 font-medium">+15</span>
            </div>
          </div>
        </div>
      </div>

      <!-- active issue workspace -->
      <div class="col-12">
        <app-active-issue-table></app-active-issue-table>
      </div>

      <!-- recent changes summary -->
      <div class="col-12">
        <div class="recent-changes">
          <div class="recent-changes__header">
            <i class="pi pi-history"></i>
            <div>
              <span class="recent-changes__label">Recent changes</span>
              <span class="recent-changes__sub"
                >Latest updates to active issues across the fleet</span
              >
            </div>
          </div>

          <div *ngIf="recentChangesLoading" class="recent-changes__loading">
            <p-progressBar
              mode="indeterminate"
              styleClass="w-full"
            ></p-progressBar>
          </div>

          <div
            *ngIf="!recentChangesLoading && recentChanges.length === 0"
            class="recent-changes__empty"
          >
            <i class="pi pi-check-circle"></i>
            <span>No recent changes</span>
          </div>

          <ul
            *ngIf="!recentChangesLoading && recentChanges.length > 0"
            class="recent-changes__list"
          >
            <li *ngFor="let change of recentChanges" class="recent-change">
              <span class="recent-change__vehicle">
                <i class="pi pi-truck"></i>
                {{ change.vehicle_reference || "—" }}
              </span>
              <span
                class="recent-change__status"
                [class.recent-change__status--closed]="change.signed_off"
              >
                {{ change.signed_off ? "Signed off" : "Updated" }}
                <ng-container *ngIf="change.signoff_type"
                  >· {{ change.signoff_type }}</ng-container
                >
              </span>
              <span class="recent-change__time">{{
                change.date_updated | dateAsAgo
              }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
